/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { IPermission } from "../../../models/Permission/PermissionContract";
import { GET_ALL_PERMISSION, GET_PERMISSION } from "./types";

export const getPermissionAction = (permission?: IPermission | []) => {
  return {
    type: GET_PERMISSION,
    permission
  };
};

export const getAllPermissionAction = (permissions: IPermission[] | []) => {
  return {
    type: GET_ALL_PERMISSION,
    permissions
  };
};